import {CommandeFormationStore} from "@common/store/commande-formation.store";
import {Router} from "@angular/router";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Component} from "@angular/core";
import {ArianeElement, ArianeStore} from "@digicerba/common";
import {
  FormationDto,
  ICommandeFormationWebServiceClient,
  ModePaiementEnum,
  OrganismeCommanditaireDto,
  SaveParticipantFormationDto
} from "@common/resources/resources";
import {Http} from "@angular/http";

import * as lodash from "lodash";

@Component({
  selector: 'recap-inscription-component',
  templateUrl: './recap-inscription.component.html',
  host: {'class': 'page'}
})
export class RecapInscriptionComponent {
  creationError: boolean;
  creationErrorMessage: string;
  paiementData: string;
  paiementError: boolean;
  paiementForm: FormGroup;

  participantFormations: Array<{
    participant: SaveParticipantFormationDto,
    participantIndex: number
    formation: FormationDto,
  }>
  total: number;

  constructor(private arianeStore: ArianeStore, private fb: FormBuilder, private commandeFormationStore: CommandeFormationStore, private http: Http,
              private commandeFormationWebServiceClient: ICommandeFormationWebServiceClient, private router: Router) {
    let arianeElements: Array<ArianeElement>;
    arianeElements = [
      {
        libelle: "Catalogue de formation",
        route: "/liste-formations"
      },
      {
        libelle: "Inscription : Paiement",
        route: "/recap-inscription"
      }
    ];

    arianeStore.updateElements(arianeElements);
  }

  ngOnInit() {
    // si on a pas de formation dans le commande store... on retourne en page 0
    if (this.commandeFormationStore.countFormations() == 0) {
      this.router.navigate(['cerba/liste-formations']);
    } else {
      this.participantFormations = []
      let participantIndex = 0;
      for (let participant of this.commandeFormationStore.getParticipantFormations()) {
        for (let formationId of participant.formationIds) {
          let formation: FormationDto = this.commandeFormationStore.getFormationById(formationId);
          if (formation != null) {
            this.participantFormations.push({participant, participantIndex, formation});
          }
        }
        participantIndex++;
      }

      this.computeTotal();

      this.paiementForm = this.fb.group({
        modePaiement: [null, Validators.required]
      });
    }
  }

  getOrganismeCommanditaire(): OrganismeCommanditaireDto {
    return this.commandeFormationStore.getOrganismeCommanditaire();
  }

  deleteInscriptionParticipant(index: number) {
    let participantFormation = this.participantFormations[index];
    this.participantFormations.splice(index, 1);
    this.commandeFormationStore.removeFormationForParticipantFormation(participantFormation.participantIndex, participantFormation.formation.id);
    this.computeTotal();
  }

  computeTotal() {
    this.total = 0;
    for (let item of this.participantFormations) {
      this.total = (this.total + (item.formation.tarif * item.formation.duree));
    }
  }

  nextStep() {
    if (this.paiementForm.valid) {
      // création de la commande
      let commandeFormation = this.commandeFormationStore.getSaveCommandeFormation();
      commandeFormation.modePaiement = <ModePaiementEnum>this.paiementForm.value.modePaiement;

      this.commandeFormationWebServiceClient.createFullCommandeFormation(commandeFormation).subscribe(data => {
        this.creationError = false;
        this.commandeFormationStore.setCommandeFormation(data);
        if (this.commandeFormationStore.getCommandeFormation().modePaiement == 'CHEQUE') {
          this.handlePaiementCheque();
        } else {
          this.handlePaiementEnLigne();
        }
      }, error => {
        // échec création commande
        this.handleCreationError(error);
      });
    }
  }

  private handlePaiementCheque() {
    // aller au recap commande
    this.commandeFormationWebServiceClient.validateCommandeFormation(this.commandeFormationStore.getCommandeFormation().id).subscribe(data => {
        this.commandeFormationStore.emptySaveCommandeFormation();
        this.commandeFormationStore.setCommandeFormation(data);
        console.log("Commande:" + data.id + " payée par chèque");
        this.router.navigate(['cerba/recap-commande'], "mode=CHEQUE");
      },
      error => {
        console.log("Update failed:" + error);
        this.commandeFormationStore.emptyCommandeFormation(true);
      });
  }

  private handlePaiementEnLigne() {
    // démarrer le paiement en ligne
    this.http.post('/catalogue-formation/api/commande/startTransaction', this.commandeFormationStore.getCommandeFormation().id)
      .map(res => res.text())
      .subscribe(
        data => {
          // paiement en ligne près => afficher choix de carte
          this.paiementData = data;
          this.paiementError = false;
        },
        () => {
          // erreur paiement en ligne
          this.paiementData = null;
          this.paiementError = true;
          this.commandeFormationStore.emptyCommandeFormation(true);
        });
  }

  private handleCreationError(error: any) {
    console.log("Plus de participants?" + error + "/" + error._body);
    if (error.status == 422) {
      this.creationError = true;
      if (error._body !== null) {
        let bodyObject = JSON.parse(error._body);
        let elements = bodyObject.message.split(":");
        if (elements.length > 1) {
          this.creationErrorMessage = lodash.join(
            lodash.map(
              lodash.filter(this.commandeFormationStore.getFormations(),
                (formation) => {
                  if (formation.id == elements[1]) {
                    return true
                  }
                  else {
                    return false;
                  }
                }),
              (formation) => {
                return formation.reference + " (" + formation.titre + ")";
              }));
        }
      }
    }
  }

  goToHome() {
    this.router.navigate(['cerba/liste-formations']);
  }
}




// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-formation/digicerba-catalogue-formation-web/src/angular/cerba/src/app/pages/cerba/pages/commande/recap-inscription/recap-inscription.component.ts